import { ref } from 'vue';
import { defineStore } from 'pinia';

export const useDialogStore = defineStore('dialog', () => {
	const isVisibleDialogMaxCount = ref(false);

	function toggleDialogMaxCount() {
		isVisibleDialogMaxCount.value = !isVisibleDialogMaxCount.value;
	}

	function showDialogMaxCount() {
		isVisibleDialogMaxCount.value = true;
	}

	function hideDialogMaxCount() {
		isVisibleDialogMaxCount.value = false;
	}

	return {
		isVisibleDialogMaxCount,
		toggleDialogMaxCount,
		showDialogMaxCount,
		hideDialogMaxCount,
	}
});
